module.exports = __webpack_public_path__ + "img/img_family_07.643b5aba.svg";